import * as React from "react";
import Modal from "components/bootstrap/Modal";
import AIReportModalContent from "security-app/components/Investigations/AIReport/AIReportModalContent";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
const AIReportModal = ({ onCancel, investigation }) => {
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  return /* @__PURE__ */ React.createElement(Modal, { show: isAIReportFeatureEnabled, onHide: onCancel, bsSize: "large" }, /* @__PURE__ */ React.createElement(AIReportModalContent, { onClose: onCancel, investigation }));
};
export default AIReportModal;
